import React from 'react'
import styled from '@emotion/styled'
import {RadioCircle} from '../../../../../accountManagement/shared/RadioCircle'
import {theme} from '../../../../../accountManagement/theme'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2]};
`

const Question = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
`

const OptionsRow = styled.div`
  display: flex;
  gap: ${theme.space[4]};
`

const Option = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.primary};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

// Matches the error text style of the shared Input (HelperText with isError)
const ErrorText = styled.p`
  margin: 0;
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.status.danger.text};
`

const NoteText = styled.p`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.text.muted};
  margin: 0;
`

const RequiredMark = styled.span`
  color: ${theme.colors.status.danger.text};
  margin-left: ${theme.space[0.5]};
`

export function YesNoField({
  field,
  value,
  onChange,
  error,
  disabled,
  disabledNote,
}) {
  const note = disabled ? disabledNote : field.notes?.[value]
  return (
    <Wrapper>
      <Question>
        {field.label}
        {field.validators?.includes('required') && (
          <RequiredMark>*</RequiredMark>
        )}
      </Question>
      <OptionsRow>
        <Option
          type="button"
          disabled={disabled}
          onClick={() => onChange(field.key, 'yes')}
        >
          <RadioCircle active={value === 'yes'} variant="dot" />
          Yes
        </Option>
        <Option
          type="button"
          disabled={disabled}
          onClick={() => onChange(field.key, 'no')}
        >
          <RadioCircle active={value === 'no'} variant="dot" />
          No
        </Option>
      </OptionsRow>
      {note && <NoteText>{note}</NoteText>}
      {error && <ErrorText role="alert">{error}</ErrorText>}
    </Wrapper>
  )
}
